/**
 * @generated SignedSource<<487282a693988cfe724397fce9183104>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentPixAutomaticRedirect_subscription$data = {
  readonly redirectUrl: string | null | undefined;
  readonly " $fragmentType": "PaymentPixAutomaticRedirect_subscription";
};
export type PaymentPixAutomaticRedirect_subscription$key = {
  readonly " $data"?: PaymentPixAutomaticRedirect_subscription$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentPixAutomaticRedirect_subscription">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentPixAutomaticRedirect_subscription",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "redirectUrl",
      "storageKey": null
    }
  ],
  "type": "PaymentSubscription",
  "abstractKey": null
};

(node as any).hash = "384d31da284fe01c43aafd1de43ca504";

export default node;
